import { useState } from 'react'

const FilterDropDownHook = () => {
  const [isopenpopup, setisopenpopup] = useState(false)

  const handleopenClosedropdown = () => {
    setisopenpopup(prev => !prev)
  }

  const closefilterpopupeye = () => {
    setisopenpopup(false)
  }

  return {
    handleopenClosedropdown,
    closefilterpopupeye,
    isopenpopup
  }
}

export default FilterDropDownHook
